import BackBar from "components/ui/BackBar/BackBar";
import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import useEntity from "hooks/useEntity";
import Alert from "components/ui/Alert/Alert";
import ContentContainer from "layout/Content/ContentContainer";
import Sort from "features/view/components/Sort/Sort";
import ViewContextProvider from "features/view/context/ViewContext";
import ViewFavorites from "pages/Profile/ViewFavorites";
import { ReactComponent as IconStar } from "assets/images/icons/star.svg";

function MyFavorites() {
  const { entity, error } = useEntity(window.location.pathname, 'page');

  if (error) {
    return <Alert message={ error }/>;
  }

  const sortOptions = [
    {
      id: 'created|DESC',
      value: 'Laatst toegevoegde eerst',
    },
    {
      id: 'created|ASC',
      value: 'Eerst toegevoegde eerst',
    },
    {
      id: 'title|ASC',
      value: 'Alfabetisch (oplopend)',
    },
    {
      id: 'title|DESC',
      value: 'Alfabetisch (aflopend)',
    },
  ];

  return (
    <>
      <BackBar path={ '/startpagina' } containerWidth={ 'wide' } label={ 'Naar mijn startpagina' }/>
      <ContentContainer contentGridType={ 'wide' } contentPadding={ true } contentBackground={ true }>

        <TitleWithIcon title={ entity?.title?.value } hasBottomMargin={ true }>
          <IconStar/>
        </TitleWithIcon>
        <div>
          { entity?.field_intro?.value }
        </div>

        <Sort options={ sortOptions } variant={ 'transparent-primary' } isAlignedRight={ true } fontColor={ 'primary' }/>

        <ViewContextProvider name={ 'favorites/profile' }>
          <ViewFavorites/>
        </ViewContextProvider>

      </ContentContainer>
    </>
  )
}

export default MyFavorites;
